<template>
  <VModal ref="modal" @close="$emit('close')">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
      <div class="flex flex-col divide-y">
        <div class="flex-none p-4">
          <div class="flex justify-between items-center">
            <div class="flex-1">Upload Files</div>
            <div class="flex-none">
              <button
                type="button"
                class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="closeModal"
              >
                <span class="sr-only">Close</span>
                <svg
                  class="inline-flex h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="flex-1 p-4">
          <FileUpload
            :options="{
              allowMultiple: true,
              acceptedFileTypes,
            }"
            v-model="formData.media"
          />

          <BaseButton
            primary
            :disabled="loading || formData.media.length === 0"
            @click="upload"
            class="w-full"
          >
            Save
          </BaseButton>
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import FileUpload from 'Components/FileUpload/Index.vue';

export default {
  name: 'UploadFilesDialog',
  components: {
    FileUpload,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      acceptedFileTypes: [
        'image/*',
        // 'application/pdf',
        // 'video/*',
        // 'application/msword',
        // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        // 'application/vnd.ms-powerpoint',
        // 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        // 'application/vnd.ms-excel',
        // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ],
      formData: {
        media: [],
      },
    };
  },
  methods: {
    async upload() {
      try {
        this.loading = true;
        await this.action(this.formData);

        this.resetFormData();

        this.loading = false;
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    resetFormData() {
      this.formData.media = [];
      this.formData.included = {};
    },
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
